module.exports = __webpack_public_path__ + "assets/img/svg/news/delivery-period.svg?v=1756788782935";